import React, { Component } from "react";
import { PulseLoader } from "react-spinners";
import Colors from "../assets/Colors";

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderSplash: false
    };
  }
  componentWillMount() {
    this.renderTimeout = setTimeout(() => this.setState({ renderSplash: true }), 500);
  }
  componentWillUnmount() {
    clearTimeout(this.renderTimeout);
  }

  render() {
    let mainRender = this.state.renderSplash ? (
      <div class="mx-auto text-center" style={{ paddingTop: "30vh" }}>
        <img class="mb-4" src={require("../assets/img/logo.png")} height="50" />
        {/* <h2 >Loading</h2> */}
        <PulseLoader color={Colors.main} />
      </div>
    ) : null;

    return mainRender;
  }
}

const styles = {};

export default Loading;
